// The window is only defined in the browser, so we can use it to differentiate client vs server rendering
export const isServerRendered = typeof window === 'undefined';
